import { memo, useMemo } from "react";
import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Annotation from "components/Charts/AreaChart/primitives/Annotation";
import type { LineData } from "components/charting/types/Chart.types";
import useOneRepMaxChartColor from "../useOneRepMaxChartColor";

interface OneRepMaxChartVariantLabelsProps {
  lines: LineData[];
  yAxisId: string;
}

// Tags the last point of each left or right line with its variant name.
function OneRepMaxChartVariantLabels(props: OneRepMaxChartVariantLabelsProps) {
  const { lines, yAxisId } = props;
  const getLineColor = useOneRepMaxChartColor();
  const { t } = useTranslation();
  const theme = useTheme();

  const textProps = useMemo(
    () => ({
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.TextS.fontSize,
      style: { textTransform: "uppercase" },
    }),
    [theme.typography.TextS.fontSize, theme.typography.fontFamily]
  );

  return (
    <>
      {lines.map((line) => {
        const lastPoint = line.line[line.line.length - 1];
        if (!line.variant || !lastPoint) return null;

        return (
          <Annotation
            key={line.variant}
            yAxisId={yAxisId}
            xValue={new Date(lastPoint.x)}
            yValue={lastPoint.y}
            slotProps={{ rect: { fill: getLineColor(line.variant) }, text: textProps }}
          >
            {t("measures.variant", { context: line.variant })}
          </Annotation>
        );
      })}
    </>
  );
}

export default memo(OneRepMaxChartVariantLabels);
